var _path, _path2, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstorebadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_on_the_App_Store_Badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.875,
    height: 45,
    viewBox: "0 0 151.875 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M146.472,45H5.32A5.332,5.332,0,0,1,0,39.675V5.317A5.325,5.325,0,0,1,5.32,0H146.472a5.4,5.4,0,0,1,5.4,5.317V39.675a5.4,5.4,0,0,1-5.4,5.325Z",
    fill: "#a6a6a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M150.675,39.565a4.309,4.309,0,0,1-4.313,4.309H5.209A4.314,4.314,0,0,1,.89,39.565V5.2A4.32,4.32,0,0,1,5.209.89H146.36A4.313,4.313,0,0,1,150.674,5.2V39.565Z",
    transform: "translate(0.111 0.111)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(14.391 6.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M32.3,20.711A6.521,6.521,0,0,1,35.4,15.239a6.679,6.679,0,0,0-5.26-2.844c-2.213-.233-4.359,1.324-5.487,1.324-1.15,0-2.886-1.3-4.756-1.263a7,7,0,0,0-5.9,3.6c-2.549,4.413-.648,10.9,1.794,14.466,1.222,1.747,2.649,3.7,4.518,3.629,1.828-.075,2.511-1.166,4.717-1.166,2.186,0,2.827,1.166,4.733,1.122,1.962-.032,3.2-1.755,4.376-3.518a14.436,14.436,0,0,0,2-4.076A6.3,6.3,0,0,1,32.3,20.711Z",
    transform: "translate(-12.792 -5.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M27.406,10.817a6.419,6.419,0,0,0,1.469-4.6A6.539,6.539,0,0,0,24.647,8.4a6.109,6.109,0,0,0-1.507,4.43A5.4,5.4,0,0,0,27.406,10.817Z",
    transform: "translate(-11.503 -6.217)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(47.711 20.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M55.049,33.167H52.495l-1.4-4.4H46.231l-1.333,4.4H42.41L47.23,18.2h2.977Zm-4.376-6.243-1.266-3.909q-.2-.6-.755-2.82h-.045q-.221.955-.711,2.82l-1.243,3.909Z",
    transform: "translate(-42.41 -17.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M65.817,27.2a6.135,6.135,0,0,1-1.488,4.353,4.352,4.352,0,0,1-3.31,1.422,3.31,3.31,0,0,1-3.066-1.532h-.045v5.687h-2.4V25.486q0-1.731-.089-3.554H57.53l.134,1.711h.045a4.268,4.268,0,0,1,6.83-.423A5.948,5.948,0,0,1,65.817,27.2Zm-2.444.088a4.444,4.444,0,0,0-.711-2.6,2.456,2.456,0,0,0-2.088-1.066,2.494,2.494,0,0,0-1.61.588,2.729,2.729,0,0,0-.944,1.545,3.14,3.14,0,0,0-.111.731v1.8a2.884,2.884,0,0,0,.722,1.989,2.394,2.394,0,0,0,1.877.811,2.455,2.455,0,0,0,2.109-1.044A4.6,4.6,0,0,0,63.374,27.285Z",
    transform: "translate(-40.784 -17.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M76.854,27.2a6.13,6.13,0,0,1-1.49,4.353,4.348,4.348,0,0,1-3.309,1.422,3.307,3.307,0,0,1-3.065-1.532h-.045v5.687h-2.4V25.486q0-1.731-.089-3.554h2.109l.134,1.711h.045a4.269,4.269,0,0,1,6.831-.423A5.964,5.964,0,0,1,76.854,27.2Zm-2.443.088a4.445,4.445,0,0,0-.712-2.6,2.452,2.452,0,0,0-2.087-1.066A2.5,2.5,0,0,0,70,24.209a2.727,2.727,0,0,0-.943,1.545,3.2,3.2,0,0,0-.111.731v1.8a2.893,2.893,0,0,0,.72,1.989,2.4,2.4,0,0,0,1.879.811,2.455,2.455,0,0,0,2.109-1.044A4.6,4.6,0,0,0,74.411,27.285Z",
    transform: "translate(-39.404 -17.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M89.071,28.993a3.99,3.99,0,0,1-1.33,3.109,5.893,5.893,0,0,1-4.078,1.311,7.139,7.139,0,0,1-3.88-.933l.556-2a6.575,6.575,0,0,0,3.467.956,3.278,3.278,0,0,0,2.112-.612,2,2,0,0,0,.754-1.636,2.085,2.085,0,0,0-.622-1.535A5.783,5.783,0,0,0,83.984,26.5q-3.932-1.466-3.931-4.293a3.8,3.8,0,0,1,1.378-3.025A5.433,5.433,0,0,1,85.1,18a7.267,7.267,0,0,1,3.4.711l-.6,1.955a5.9,5.9,0,0,0-2.865-.688,2.9,2.9,0,0,0-1.976.622,1.778,1.778,0,0,0-.6,1.356,1.83,1.83,0,0,0,.687,1.466,7.769,7.769,0,0,0,2.178,1.155,7.39,7.39,0,0,1,2.843,1.82A3.8,3.8,0,0,1,89.071,28.993Z",
    transform: "translate(-37.738 -18.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M95.818,24.007H93.175v5.241q0,2,1.4,2a4.266,4.266,0,0,0,1.065-.111l.066,1.821a5.434,5.434,0,0,1-1.865.265,2.878,2.878,0,0,1-2.222-.866,4.255,4.255,0,0,1-.8-2.91V24H89.244V22.2h1.575V20.228l2.356-.711V22.2h2.644v1.8Z",
    transform: "translate(-36.556 -17.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M106.866,27.241a5.922,5.922,0,0,1-1.422,4.087,5.077,5.077,0,0,1-3.956,1.644A4.827,4.827,0,0,1,97.7,31.4a5.74,5.74,0,0,1-1.411-3.976,5.864,5.864,0,0,1,1.455-4.109,5.034,5.034,0,0,1,3.92-1.6,4.93,4.93,0,0,1,3.821,1.577A5.675,5.675,0,0,1,106.866,27.241Zm-2.488.078a4.856,4.856,0,0,0-.644-2.562,2.369,2.369,0,0,0-2.153-1.292,2.4,2.4,0,0,0-2.2,1.292,4.949,4.949,0,0,0-.643,2.607,4.849,4.849,0,0,0,.643,2.561,2.451,2.451,0,0,0,4.331-.023A4.873,4.873,0,0,0,104.377,27.319Z",
    transform: "translate(-35.675 -17.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M113.263,24.042a4.165,4.165,0,0,0-.756-.066,2.266,2.266,0,0,0-1.955.956,3.594,3.594,0,0,0-.6,2.132v5.664h-2.4l.023-7.4q0-1.866-.09-3.4h2.089L109.664,24h.066a3.692,3.692,0,0,1,1.2-1.71,2.9,2.9,0,0,1,1.734-.578,3.851,3.851,0,0,1,.6.044v2.287Z",
    transform: "translate(-34.275 -17.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M123.222,26.822a5.625,5.625,0,0,1-.088,1.088h-7.2a3.132,3.132,0,0,0,1.044,2.445,3.564,3.564,0,0,0,2.354.755,7.958,7.958,0,0,0,2.911-.511l.376,1.665a9,9,0,0,1-3.619.667,5.243,5.243,0,0,1-3.944-1.477,5.455,5.455,0,0,1-1.432-3.965,6.185,6.185,0,0,1,1.334-4.065,4.6,4.6,0,0,1,3.774-1.731,4.023,4.023,0,0,1,3.534,1.731A5.839,5.839,0,0,1,123.222,26.822Zm-2.287-.622a3.259,3.259,0,0,0-.466-1.844,2.1,2.1,0,0,0-1.911-1,2.275,2.275,0,0,0-1.909.978,3.579,3.579,0,0,0-.71,1.865h5Z",
    transform: "translate(-33.508 -17.539)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(49.135 7.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M49.722,10.4a3.693,3.693,0,0,1-1.19,2.99,4.734,4.734,0,0,1-3.131.927,14.517,14.517,0,0,1-1.725-.088V7a12.727,12.727,0,0,1,2.031-.153,4.377,4.377,0,0,1,2.914.84A3.4,3.4,0,0,1,49.722,10.4Zm-1.243.033A2.689,2.689,0,0,0,47.8,8.462,2.687,2.687,0,0,0,45.8,7.774a4.99,4.99,0,0,0-.95.076v5.5a6.225,6.225,0,0,0,.8.033,2.789,2.789,0,0,0,2.089-.753A3.014,3.014,0,0,0,48.479,10.437Z",
    transform: "translate(-43.676 -6.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M55.486,11.339a2.909,2.909,0,0,1-.7,2.008,2.493,2.493,0,0,1-1.943.808,2.37,2.37,0,0,1-1.861-.775,2.823,2.823,0,0,1-.692-1.953,2.881,2.881,0,0,1,.714-2.018,2.478,2.478,0,0,1,1.926-.785A2.425,2.425,0,0,1,54.81,9.4,2.8,2.8,0,0,1,55.486,11.339Zm-1.223.038a2.4,2.4,0,0,0-.316-1.259,1.164,1.164,0,0,0-1.058-.635,1.183,1.183,0,0,0-1.081.635,2.431,2.431,0,0,0-.316,1.28,2.4,2.4,0,0,0,.316,1.259,1.19,1.19,0,0,0,1.07.635,1.176,1.176,0,0,0,1.057-.646A2.383,2.383,0,0,0,54.263,11.377Z",
    transform: "translate(-42.849 -6.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M63.619,8.719l-1.659,5.3h-1.08l-.687-2.3a17.233,17.233,0,0,1-.426-1.713h-.021a12.543,12.543,0,0,1-.426,1.713l-.73,2.3H57.5l-1.56-5.3h1.212l.6,2.521q.218.894.36,1.7h.021q.132-.665.438-1.691l.753-2.531h.961L61,11.2q.262.906.425,1.746h.033a16.683,16.683,0,0,1,.36-1.746l.643-2.477h1.158Z",
    transform: "translate(-42.144 -6.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M68.715,14.035H67.536V11q0-1.4-1.069-1.4a1.064,1.064,0,0,0-.852.386,1.369,1.369,0,0,0-.327.909v3.146H64.109V10.247q0-.7-.043-1.518H65.1l.055.829h.033a1.7,1.7,0,0,1,.611-.64,1.993,1.993,0,0,1,1.069-.3A1.692,1.692,0,0,1,68.1,9.1a2.334,2.334,0,0,1,.611,1.757Z",
    transform: "translate(-41.127 -6.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M71.219,14.293H70.041V6.556h1.178Z",
    transform: "translate(-40.38 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M77.835,11.339a2.909,2.909,0,0,1-.7,2.008,2.5,2.5,0,0,1-1.943.808,2.367,2.367,0,0,1-1.861-.775,2.823,2.823,0,0,1-.692-1.953,2.881,2.881,0,0,1,.714-2.018,2.477,2.477,0,0,1,1.925-.785,2.428,2.428,0,0,1,1.879.774A2.8,2.8,0,0,1,77.835,11.339Zm-1.224.038a2.4,2.4,0,0,0-.316-1.259,1.163,1.163,0,0,0-1.056-.635,1.18,1.18,0,0,0-1.081.635,2.431,2.431,0,0,0-.316,1.28,2.4,2.4,0,0,0,.316,1.259,1.19,1.19,0,0,0,1.07.635,1.175,1.175,0,0,0,1.056-.646A2.373,2.373,0,0,0,76.611,11.377Z",
    transform: "translate(-40.055 -6.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M82.814,14.034H81.755l-.088-.611h-.033a1.816,1.816,0,0,1-1.549.731,1.6,1.6,0,0,1-1.21-.48,1.506,1.506,0,0,1-.415-1.08,1.648,1.648,0,0,1,.813-1.484,4.221,4.221,0,0,1,2.287-.5v-.1q0-1.048-1.1-1.047a2.467,2.467,0,0,0-1.383.393l-.24-.774a3.4,3.4,0,0,1,1.819-.458q2.079,0,2.081,2.194V12.77A8.281,8.281,0,0,0,82.814,14.034ZM81.59,12.212v-.818q-1.951-.034-1.951,1.069a.8.8,0,0,0,.226.622.825.825,0,0,0,.576.207,1.191,1.191,0,0,0,.721-.245,1.007,1.007,0,0,0,.428-.835Z",
    transform: "translate(-39.328 -6.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M88.848,14.293H87.8l-.055-.852h-.033a1.763,1.763,0,0,1-1.7.972,2,2,0,0,1-1.593-.753,2.932,2.932,0,0,1-.632-1.953,3.075,3.075,0,0,1,.687-2.085,2.113,2.113,0,0,1,1.637-.742A1.589,1.589,0,0,1,87.6,9.6h.022V6.556h1.18v6.308Q88.806,13.638,88.848,14.293Zm-1.222-2.236v-.884a1.736,1.736,0,0,0-.033-.371,1.343,1.343,0,0,0-.426-.714,1.159,1.159,0,0,0-.789-.289,1.21,1.21,0,0,0-1.037.524,2.247,2.247,0,0,0-.378,1.342,2.094,2.094,0,0,0,.362,1.277,1.213,1.213,0,0,0,1.031.523,1.136,1.136,0,0,0,.932-.436A1.453,1.453,0,0,0,87.626,12.056Z",
    transform: "translate(-38.662 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M97.825,11.339a2.909,2.909,0,0,1-.7,2.008,2.492,2.492,0,0,1-1.943.808,2.373,2.373,0,0,1-1.861-.775,2.823,2.823,0,0,1-.692-1.953,2.881,2.881,0,0,1,.714-2.018,2.479,2.479,0,0,1,1.927-.785,2.423,2.423,0,0,1,1.876.774A2.8,2.8,0,0,1,97.825,11.339Zm-1.222.038a2.4,2.4,0,0,0-.316-1.259,1.166,1.166,0,0,0-1.059-.635,1.185,1.185,0,0,0-1.081.635,2.431,2.431,0,0,0-.316,1.28,2.4,2.4,0,0,0,.316,1.259,1.2,1.2,0,0,0,2.128-.011A2.394,2.394,0,0,0,96.6,11.377Z",
    transform: "translate(-37.557 -6.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M103.4,14.035h-1.178V11q0-1.4-1.07-1.4a1.06,1.06,0,0,0-.85.386,1.363,1.363,0,0,0-.327.909v3.146h-1.18V10.247q0-.7-.042-1.518h1.035l.055.829h.033a1.721,1.721,0,0,1,.611-.64,2,2,0,0,1,1.07-.3,1.692,1.692,0,0,1,1.233.48,2.33,2.33,0,0,1,.611,1.757Z",
    transform: "translate(-36.792 -6.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M110.295,9.749H109v2.576c0,.655.231.982.687.982a2.076,2.076,0,0,0,.525-.055l.03.894a2.649,2.649,0,0,1-.916.132,1.409,1.409,0,0,1-1.09-.425,2.08,2.08,0,0,1-.394-1.43V9.749h-.775V8.866h.775V7.894L109,7.545v1.32h1.3v.884Z",
    transform: "translate(-35.752 -6.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M116,14.293h-1.18V11.278q0-1.426-1.068-1.426a1.125,1.125,0,0,0-1.125.827,1.482,1.482,0,0,0-.055.424v3.189H111.39V6.556h1.178v3.2h.022a1.782,1.782,0,0,1,1.593-.872,1.643,1.643,0,0,1,1.213.48,2.415,2.415,0,0,1,.6,1.779v3.153Z",
    transform: "translate(-35.212 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M121.731,11.133a2.848,2.848,0,0,1-.044.534h-3.536a1.546,1.546,0,0,0,.512,1.2,1.756,1.756,0,0,0,1.158.371,3.906,3.906,0,0,0,1.43-.251l.185.819a4.44,4.44,0,0,1-1.78.327,2.57,2.57,0,0,1-1.936-.726,2.673,2.673,0,0,1-.7-1.947,3.035,3.035,0,0,1,.655-2,2.255,2.255,0,0,1,1.854-.851,1.972,1.972,0,0,1,1.734.851A2.831,2.831,0,0,1,121.731,11.133Zm-1.125-.3a1.587,1.587,0,0,0-.228-.906,1.03,1.03,0,0,0-.938-.492,1.119,1.119,0,0,0-.938.48,1.785,1.785,0,0,0-.35.917h2.455Z",
    transform: "translate(-34.509 -6.299)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstorebadge);
export default __webpack_public_path__ + "static/media/appstorebadge.381406d7132e6bb93bdd2542fca7557c.svg";
export { ForwardRef as ReactComponent };